import axios from "axios";
const endpoint = process.env.VUE_APP_BASE_API + "/api/master/termscondition";

export default {
  async getAll() {
    return await axios
      .get(endpoint)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async getById(id) {
    return await axios
      .get(endpoint + `/${id}`)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async saveToDraft(request) {
    return await axios
      .post(endpoint + `/draft`, request)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async publish(request) {
    return await axios
      .post(endpoint + "/publish", request)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  }
};



// WEBPACK FOOTER //
// ./src/services/master/termsCondition/termsConditionService.js